import React from 'react';
// @ts-ignore
import EmptyState from './assets/empty-list-icon.svg';
import './no-billing-profile.scss';

export const NoBillingProfile = ({
  LinkToCustomerBillingProfile = <></>,
  isAddBPDisabled = false,
}: {
  LinkToCustomerBillingProfile?: React.ReactNode;
  isAddBPDisabled?: boolean;
}) => {
  return (
    <div className="flex-column justify-center align-center no-billing-profile pa-32">
      {/* @ts-ignore */}
      <img src={EmptyState} alt="No billing profile" width="56px" height="52px" />
      <p className="no-billing-profile-description mt-16">No billing profile found.</p>
      {!isAddBPDisabled && (
        <>
          <p>Add the billing profile and re-visit the current screen.</p>
          <p className="no-billing-profile-description mt-16" data-testId="link-to-customer-billing-profile">
            {LinkToCustomerBillingProfile}
          </p>
        </>
      )}
    </div>
  );
};
